import React from 'react';
import InvoiceRequests from './InvoiceRequests';

const InvoiceRequestsPage = () => (
    <div className="p-4">
        <InvoiceRequests isActive={true} />
    </div>
);

export default InvoiceRequestsPage;
